module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxIIzI.7370c367.woff2";